import { PlaceFurnitureCommand } from "../../core/commands/PlaceFurnitureCommand";
import { getComponent } from "../../world/Entity";
import type { Interaction } from "../Interaction";

/** Places a scene entity (already being dragged) onto a surface, e.g. the magnifying glass on the table. */
export const placeInteraction: Interaction = {
  id: "place",
  label: "Place",
  scope: "scene",
  canExecute: (ctx) => {
    if (!ctx.entity || !ctx.surfaceEntityId) return false;
    const surface = ctx.world.getEntity(ctx.surfaceEntityId);
    const surfaceComponent = surface && getComponent(surface, "surface");
    if (!surfaceComponent) return false;
    if (!surfaceComponent.acceptedKinds) return true;
    return surfaceComponent.acceptedKinds.includes(ctx.entity.kind);
  },
  execute: async (ctx) => {
    if (!ctx.entity || !ctx.surfaceEntityId) return { success: false };
    ctx.commands.execute(
      new PlaceFurnitureCommand(ctx.entity.id, ctx.surfaceEntityId, ctx.position ?? { x: 0, y: 0 }),
    );
    return { success: true };
  },
};
